import React from 'react';

// Generate geometric avatar from username
const generateAvatar = (name) => {
  if (!name) return null;

  // Hash the username to get consistent random values
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash = hash & hash;
  }

  // Generate 9 blocks (3x3 grid) - use symmetry for better aesthetics
  const colors = ['#84cc16', '#eab308', '#f97316', '#ef4444', '#a855f7', '#06b6d4'];
  const blocks = [];

  for (let i = 0; i < 9; i++) {
    const shouldFill = Math.abs(hash * (i + 1)) % 100 > 40; // 60% fill rate
    const colorIndex = Math.abs(hash * (i + 7)) % colors.length;
    blocks.push({
      filled: shouldFill,
      color: colors[colorIndex]
    });
  }

  return blocks;
};

export const GeometricAvatar = ({ username, size = 32 }) => {
  const blocks = generateAvatar(username);
  if (!blocks) return null;

  const blockSize = size / 3;

  return (
    <div
      className="inline-block border-2 border-black"
      style={{
        width: size,
        height: size,
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(3, 1fr)',
        gap: 0
      }}
    >
      {blocks.map((block, i) => (
        <div
          key={i}
          style={{
            backgroundColor: block.filled ? block.color : '#000000',
            width: blockSize,
            height: blockSize
          }}
        />
      ))}
    </div>
  );
};
